import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { buildHttpParams } from '../../../../core/utils/http-util';
import { endpoints } from '../../../core/constants/endpoints';
import { IClassificacaoPLMFilter } from '../interfaces/classificacao-plm-filter.interface';
import { IClassificacaoPLMResponse } from '../interfaces/classificacao-plm-response.interface';
import { IClassificacaoPLM } from '../interfaces/classificacao-plm.interface';

@Injectable({
	providedIn: 'root',
})
export class ClassificacaoPLMApi {
	private apiUrl = `${environment.pathApi}/${endpoints.product.classificacoesPlm}`;

	constructor(private http: HttpClient) {}

  fetchAll(filters?: IClassificacaoPLMFilter): Observable<IClassificacaoPLMResponse> {
    const params = buildHttpParams(filters);
    return this.http.get<IClassificacaoPLMResponse>(this.apiUrl, { params });
  }

  fetchList(): Observable<IClassificacaoPLMResponse> {
    const queryParams = {
      situacoes: 1,
      sort: 'codigo',
      sortDir: 'asc'
    };

    const querys = buildHttpParams(queryParams);
    return this.http.get<IClassificacaoPLMResponse>(`${this.apiUrl}/0/list`, { params: querys });
  }

	fetchById(id: number): Observable<IClassificacaoPLM> {
		return this.http.get<IClassificacaoPLM>(`${this.apiUrl}/${id}`);
	}

	create(payload: IClassificacaoPLM): Observable<IClassificacaoPLM> {
		return this.http.post<IClassificacaoPLM>(`${this.apiUrl}`, payload);
	}

	update(id: number, payload: IClassificacaoPLM): Observable<IClassificacaoPLM> {
		return this.http.put<IClassificacaoPLM>(`${this.apiUrl}/${id}`, payload);
	}

  delete(id: number): Observable<string> {
    return this.http.delete<string>(`${this.apiUrl}/${id}`);
  }
}
